export default __webpack_public_path__ + "static/media/phoneEquipTextMb3.b4f79142.png";